import { stateInCountry } from "../services/thirdParty/citiesNowApi";

export const getStateBasedOnCountry = async (country) => {
    const params = {
        country: country
    }
    const stateList = await stateInCountry(params);
    return stateList;
}   